export const BUSINESS_TRADE_OPTIONS = [
  'General contractor',
  'Construction company',
  'Handyman/Handywoman/Handyperson',
  'Remodeler',
  'Electrician',
  'Carpenter',
  'HVAC contractor',
  'Plumber',
] as const;

export const OTHER_BUSINESS_TRADE = 'Other';
